export const inputCls =
  "w-full rounded-2xl border-2 border-dano-ink/25 bg-white/60 px-4 py-3 text-base text-dano-ink placeholder:text-dano-ink/45 outline-none transition-[border-color,background-color] duration-300 focus:border-dano-red focus:bg-white";

export const Field = ({ label, name, required, textarea, testId, className = "", ...rest }) => (
  <label className={`block ${className}`}>
    <span className="mb-2 block font-cond text-sm uppercase tracking-[0.18em] text-dano-ink/80">
      {label} {required && <span className="text-dano-red">*</span>}
    </span>
    {textarea ? (
      <textarea name={name} required={required} rows={5} data-testid={testId} className={inputCls} {...rest} />
    ) : (
      <input name={name} required={required} data-testid={testId} className={inputCls} {...rest} />
    )}
  </label>
);

export const SelectField = ({ label, name, options, testId, value, onChange, className = "" }) => (
  <label className={`block ${className}`}>
    <span className="mb-2 block font-cond text-sm uppercase tracking-[0.18em] text-dano-ink/80">{label}</span>
    <select name={name} value={value} onChange={onChange} data-testid={testId} className={`${inputCls} appearance-none`}>
      <option value="">Select…</option>
      {options.map((o) => <option key={o} value={o}>{o}</option>)}
    </select>
  </label>
);
